import styled from 'styled-components';

export const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
`;

export const Title = styled.h3`
  font-family: inherit;
  font-weight: 500;
  font-size: 28px;
  line-height: 100%;
  letter-spacing: 0.001em;
  text-align: center;
  margin: 0;
  color: var(--way-colors-primaryTextColor);
`;

export const Subtitle = styled.p`
  font-size: 16px;
  margin: 0;
  color: var(--way-colors-tertiaryTextColor);
`;
